
sap["ls"]["preload"]["UCF_AcfAdapter"] = function() {/* global _trace, DEBUG, INFO, WARNING */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>

/**
 * @class
 * 
 * @extends UCF_Control
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_AcfAdapter(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["UCF_AcfAdapter"]++; }; 

	if (arguments["length"] === 0) return;

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["attachLSEvent"](this["oLS"]["E_EVENTS"]["PendingRequest"], "onPendingRequest");

	var oBrowserWindow = this["oLS"]["oBrowserWindow"];

	// consider Drag&Drop specialties for locking
	oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["Lock"], this, "onLock");
	oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["Unlock"], this, "onUnlock");

	oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["LayersVisible"], this, "onLayersVisible");
	oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["LayersHidden"], this, "onLayersHidden");

	this["bKeepAlive"] = true;
	/** @type {UCF_Control} */
	this["oControl"] = null;
	/** @type {HTMLElement} */
	this["oObjectRef"] = null;
	this["bLoaded"] = false; // eslint-disable-line @ur/no-memory-leaks
	this["bInitialized"] = false;
	this["bIsServiceEvent"] = false;
	this["iParamCount"] = 0;
	this["mEventParameters"] = {};
	this["bDestroyed"] = false;
	this["bLockFreeze"] = oBrowserWindow["bIsLocked"](); // eslint-disable-line @ur/no-memory-leaks

	// Note: JIRA WDAUIUR1-1547
	// We "unofficially" support active content in a single DIV-popup for WDA.
	// If the AC is contained in a PW then a single "layer" is visible.
	// We do explicitly NOT support multible nested popups with AC.
	this["bLayerFreeze"] = (this["bHasParentPopupWindow"]() !== true && oBrowserWindow["bLayersVisible"]()); // eslint-disable-line @ur/no-memory-leaks

	this["sTimeoutId"] = null; // eslint-disable-line @ur/no-memory-leaks

	if (this["iTimeout"] > 0) {
		this["sTimeoutId"] = UCF_JsUtil["delayedCall"](this["iTimeout"] * 1000, this, "onTimeout");
	}

};window["UCF_AcfAdapter"] = UCF_AcfAdapter; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AcfAdapter"); UCF_AcfAdapter["_"] = {UCF_AcfAdapter: 0}; }; 
UCF_AcfAdapter["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_AcfAdapter.prototype["sClassName"] = "UCF_AcfAdapter";

/**
 * Inititalize ACF
 */
UCF_AcfAdapter["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["initialize"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Loaded: " + this["bLoaded"], "AcfAdapter.js(70): initialize"); };
	if (this["bLoaded"]) {
		if (!this["bInitialized"]) {
			this["doInitialize"]();
		} else {
			this["invoke"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["initialize"] = 0; };

/**
 * Inititalize ACF after load
 */
UCF_AcfAdapter["prototype"]["doInitialize"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["doInitialize"]++; }; 
	if (this["sTimeoutId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sTimeoutId"]);
		this["sTimeoutId"] = null;
	}
	this["oObjectRef"] = this["oGetObjectRef"]();
	// Silverlight does not offer the ACF methods on the object itself
	if (UCF_JsUtil["bInstanceOf"](this["oControl"], "UCF_SilverlightContainer")) {
		this["oObjectRef"] = this["oObjectRef"]["Content"]["WDIsland"];
	}
	this["setBaseUrl"]();
	this["bInitialized"] = true;
	this["invoke"]();
	if (this["bLockFreeze"] || this["bLayerFreeze"]) this["oObjectRef"]["freeze"]();
	if (this["oPendingRequest"]) {
		this["oPendingRequest"]["resume"](this["sId"]);
		this["oPendingRequest"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["doInitialize"] = 0; };

/**
 * Destructor
 */
UCF_AcfAdapter["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["destroy"]++; }; 

	if (this["bDestroyed"]) return;
	this["bDestroyed"] = true;

	delete UCF_AcfAdapter["mInstances"][this["oControl"]["sId"]];
	delete UCF_AcfAdapter["mLoaded"][this["oControl"]["sId"]];

	this["bKeepAlive"] = false;
	this["oControl"] = null;
	this["mEventParameters"] = null;
	this["oObjectRef"] = null;

	var oBrowserWindow = this["oLS"]["oBrowserWindow"];
	oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["Lock"], this);
	oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["Unlock"], this);
	oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["LayersVisible"], this);
	oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["LayersHidden"], this);

	this["detachLSEvent"](this["oLS"]["E_EVENTS"]["PendingRequest"]);
	this["oPendingRequest"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["destroy"] = 0; };

/**
 * Timeout handling
 */
UCF_AcfAdapter["prototype"]["onTimeout"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onTimeout"]++; }; 
	this["fireTimeout"](this["sId"]);
	if (this["oPendingRequest"]) {
		this["oPendingRequest"]["resume"](this["sId"]);
		this["oPendingRequest"] = null;
	}
	this["detachLSEvent"](this["oLS"]["E_EVENTS"]["PendingRequest"]);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onTimeout"] = 0; };

/**
 * Set control
 * @param {UCF_Control} oControl
 */
UCF_AcfAdapter["prototype"]["setControl"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["setControl"]++; }; 
	this["oControl"] = oControl;

	this["bLoaded"] = UCF_AcfAdapter["mLoaded"][oControl["sId"]];
	UCF_AcfAdapter["mInstances"][oControl["sId"]] = this;

};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["setControl"] = 0; };

/**
 * Handler for PendingRequest event
 *
 * @param {UCF_Event} oEvent
 */
UCF_AcfAdapter["prototype"]["onPendingRequest"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onPendingRequest"]++; }; 
	this["oPendingRequest"] = oEvent["oGetParam"]("oPendingRequest");
	if (!this["bInitialized"]) {
		this["oPendingRequest"]["suspend"](this["sId"]);
	} else {
		if (this["oControl"]["bVisible"]) this["oObjectRef"]["saveChanges"]();
		this["oPendingRequest"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onPendingRequest"] = 0; };

/**
 * @return {HTMLElement} object reference(DOM object of the control)
 */
UCF_AcfAdapter["prototype"]["oGetObjectRef"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["oGetObjectRef"]++; }; 
	return this["oControl"]["oGetObjectRef"]();
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["oGetObjectRef"] = 0; };

/**
 * Forward bDoKeepAlive to active component, to be kept alive
 * as long as the control we are connected to
 * @return {boolean}
 */
UCF_AcfAdapter["prototype"]["bDoKeepAlive"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["bDoKeepAlive"]++; }; 
	if (this["bDestroyed"]) return false;
	return this["oControl"]["bDoKeepAlive"]();
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["bDoKeepAlive"] = 0; };

/**
 * Needs special reconnectToDom methods, as it can be kept alive,
 * although it has no valid dom reference
 */
UCF_AcfAdapter["prototype"]["reconnectToDom"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["reconnectToDom"]++; }; 
	if (!UCF_DomUtil["$"](this["sId"])) return;
	UCF_Control.prototype["reconnectToDom"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["reconnectToDom"] = 0; };

/**
 * Get the base URL for this application
 * @return {string} base URL
 */
UCF_AcfAdapter["prototype"]["sGetBaseUrl"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["sGetBaseUrl"]++; }; 
	var sBaseUrl = location["href"],
		iQuestionMarkPos = sBaseUrl["indexOf"]("?");
	if (iQuestionMarkPos > 0) sBaseUrl = sBaseUrl["substr"](0, iQuestionMarkPos);
	return sBaseUrl;
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["sGetBaseUrl"] = 0; };

/**
 * Initialize ACF control
 */
UCF_AcfAdapter["prototype"]["setBaseUrl"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["setBaseUrl"]++; }; 
	this["oObjectRef"]["setBaseUrl"](this["sGetBaseUrl"]());
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["setBaseUrl"] = 0; };

/**
 * Set invocation XML
 */
UCF_AcfAdapter["prototype"]["invoke"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["invoke"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Invoke: " + this["oDomRef"]["innerHTML"], "AcfAdapter.js(218): invoke"); };
	var sReturnValue = "",
		sInvokeMethod = "invoke",
		sInvokeXML = this["oDomRef"]["innerHTML"];

	// Flash Specific stuff
	if (UCF_JsUtil["bInstanceOf"](this["oControl"], "UCF_FlashContainer")) {
		// The flash ActiveX uses "invoke" internally, so we user "invokeData" instead
		sInvokeMethod = "invokeData";

		// replace 0D0A with single 0A (see int 3845611 2009)
		if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Invoke length retrieved : " + sInvokeXML["length"], "AcfAdapter.js(230): invoke"); };
			sInvokeXML = sInvokeXML["replace"](/\r\n/g, "\n");
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Invoke length normalized: " + sInvokeXML["length"], "AcfAdapter.js(232): invoke"); };
		}
	}

	sReturnValue = this["oObjectRef"][sInvokeMethod](sInvokeXML);

	// Convert Java string to JS string (Firefox)
	sReturnValue = "" + sReturnValue;
	this["fireReturnValue"](this["sId"], sReturnValue);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["invoke"] = 0; };

/**
 * Freeze ACF control
 */
UCF_AcfAdapter["prototype"]["freeze"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["freeze"]++; }; 
	if (this["bInitialized"] && !(this["bLayerFreeze"] || this["bLockFreeze"])) {
		this["oObjectRef"]["freeze"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["freeze"] = 0; };

/**
 * Unfreeze ACF control
 */
UCF_AcfAdapter["prototype"]["unfreeze"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["unfreeze"]++; }; 
	if (this["bInitialized"] && !(this["bLayerFreeze"] || this["bLockFreeze"])) {
		this["oObjectRef"]["unfreeze"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["unfreeze"] = 0; };

/**
 * onLock - freeze only when no Drag&Drop is pending
 */
UCF_AcfAdapter["prototype"]["onLock"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onLock"]++; }; 
	if (this["oLS"]["oBrowserWindow"]["bLockedAsDragDrop"]()) {
		this["bLockFreeze"] = true;
		return;
	}
	this["freeze"]();
	this["bLockFreeze"] = true;
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onLock"] = 0; };

/**
 * onUnlock - unfreeze only when no Drag&Drop is pending
 */
UCF_AcfAdapter["prototype"]["onUnlock"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onUnlock"]++; }; 
	if (this["oLS"]["oBrowserWindow"]["bLockedAsDragDrop"]()) {
		this["bLockFreeze"] = false;
		return;
	}
	this["bLockFreeze"] = false;
	this["unfreeze"]();
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onUnlock"] = 0; };

/**
 * onLayersVisible
 */
UCF_AcfAdapter["prototype"]["onLayersVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onLayersVisible"]++; }; 
	if (this["bHasParentPopupWindow"]() !== true) {
		this["freeze"]();
		this["bLayerFreeze"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onLayersVisible"] = 0; };

/**
 * onLayersHidden
 */
UCF_AcfAdapter["prototype"]["onLayersHidden"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onLayersHidden"]++; }; 
	this["bLayerFreeze"] = false;
	this["unfreeze"]();
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onLayersHidden"] = 0; };

/**
 * Static map for ACF instances
 */
UCF_AcfAdapter["mInstances"] = {};
UCF_AcfAdapter["mLoaded"] = {};

/**
 * ACF API forwarder for calls coming from the ACF
 * @param {string} sId id
 */
UCF_AcfAdapter["notifyLoad"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["notifyLoad"]++; }; 
	var oInstance = UCF_AcfAdapter["mInstances"][sId];
	UCF_AcfAdapter["mLoaded"][sId] = true;
	if (oInstance) UCF_JsUtil["delayedCall"](0, oInstance, "notifyLoad");
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["notifyLoad"] = 0; };
UCF_AcfAdapter["createEvent"] = function(sId, sCommand) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createEvent"]++; }; 
	var oInstance = UCF_AcfAdapter["mInstances"][sId];
	if (oInstance) {
		oInstance["createEvent"](sCommand);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Active component \"" + sId + "\" called createEvent, but no AcfAdapter exists for this ID.", "AcfAdapter.js(323): createEvent"); };
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createEvent"] = 0; };
UCF_AcfAdapter["createServiceEvent"] = function(sId, sCommand) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createServiceEvent"]++; }; 
	var oInstance = UCF_AcfAdapter["mInstances"][sId];
	if (oInstance) {
		oInstance["createServiceEvent"](sCommand);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Active component \"" + sId + "\" called createServiceEvent, but no AcfAdapter exists for this ID.", "AcfAdapter.js(331): createServiceEvent"); };
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createServiceEvent"] = 0; };
UCF_AcfAdapter["addEventParameter"] = function(sId, sName, sValue) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["addEventParameter"]++; }; 
	var oInstance = UCF_AcfAdapter["mInstances"][sId];
	if (oInstance) {
		oInstance["addEventParameter"](sName, sValue);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Active component \"" + sId + "\" called addEventParameter, but no AcfAdapter exists for this ID.", "AcfAdapter.js(339): addEventParameter"); };
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["addEventParameter"] = 0; };
UCF_AcfAdapter["fireEvent"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireEvent"]++; }; 
	var oInstance = UCF_AcfAdapter["mInstances"][sId];
	if (oInstance) {
		oInstance["doFireEvent"]();
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Active component \"" + sId + "\" called fireEvent, but no AcfAdapter exists for this ID.", "AcfAdapter.js(347): fireEvent"); };
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireEvent"] = 0; };
UCF_AcfAdapter["setAttribute"] = function(sId, sName, sValue) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["setAttribute"]++; }; 
	var oInstance = UCF_AcfAdapter["mInstances"][sId];
	if (oInstance) {
		oInstance["setAttribute"](sName, sValue);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Active component \"" + sId + "\" called setAttribute, but no AcfAdapter exists for this ID.", "AcfAdapter.js(355): setAttribute"); };
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["setAttribute"] = 0; };
UCF_AcfAdapter["trace"] = function(sId, sClassName, sMethodName, iSeverity, sDescription) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["trace"]++; }; 
	var oInstance = UCF_AcfAdapter["mInstances"][sId];
	if (oInstance) {
		oInstance["trace"](sClassName, sMethodName, iSeverity, sDescription);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Active component \"" + sId + "\" called trace, but no AcfAdapter exists for this ID.", "AcfAdapter.js(363): trace"); };
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["trace"] = 0; };
UCF_AcfAdapter["getDragSession"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["getDragSession"]++; }; 
	var oInstance = UCF_AcfAdapter["mInstances"][sId];
	if (oInstance) {
		return oInstance["getDragSession"]();
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Active component \"" + sId + "\" called getDragSession, but no AcfAdapter exists for this ID.", "AcfAdapter.js(371): getDragSession"); };
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["getDragSession"] = 0; };
UCF_AcfAdapter["createDragSession"] = function(sId, sDragSessionData) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createDragSession"]++; }; 
	var oInstance = UCF_AcfAdapter["mInstances"][sId];
	if (oInstance) {
		return oInstance["createDragSession"](sDragSessionData);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Active component \"" + sId + "\" called createDragSession, but no AcfAdapter exists for this ID.", "AcfAdapter.js(380): createDragSession"); };
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createDragSession"] = 0; };
UCF_AcfAdapter["destroyDragSession"] = function(sId, sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["destroyDragSession"]++; }; 
	var oInstance = UCF_AcfAdapter["mInstances"][sId];
	if (oInstance) {
		oInstance["destroyDragSession"](sDragSessionId);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Active component \"" + sId + "\" called destroyDragSession, but no AcfAdapter exists for this ID.", "AcfAdapter.js(389): destroyDragSession"); };
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["destroyDragSession"] = 0; };

/**
 * ACF API function currently no in use
 * @param {string} sId id
 */
UCF_AcfAdapter["notifyHooked"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["notifyHooked"]++; }; 
	// not used
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["notifyHooked"] = 0; };
UCF_AcfAdapter["lock"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["lock"]++; }; 
	// not used
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["lock"] = 0; };
UCF_AcfAdapter["unLock"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["unLock"]++; }; 
	// not used
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["unLock"] = 0; };
UCF_AcfAdapter["gotFocus"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["gotFocus"]++; }; 
	// not used
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["gotFocus"] = 0; };
UCF_AcfAdapter["lostFocus"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["lostFocus"]++; }; 
	// not used
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["lostFocus"] = 0; };
UCF_AcfAdapter["tabToNext"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["tabToNext"]++; }; 
	// not used
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["tabToNext"] = 0; };
UCF_AcfAdapter["tabToPrevious"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["tabToPrevious"]++; }; 
	// not used
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["tabToPrevious"] = 0; };
UCF_AcfAdapter["getPagePointer"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["getPagePointer"]++; }; 
	return "";
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["getPagePointer"] = 0; };

/**
 * Callback function to notify that the control is loaded and ready for commands
 */
UCF_AcfAdapter["prototype"]["notifyLoad"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["notifyLoad"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Intitialized: " + this["bInitialized"], "AcfAdapter.js(426): notifyLoad"); };
	this["bLoaded"] = true;

	if (!this["bInitialized"]) {
		this["doInitialize"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["notifyLoad"] = 0; };

/**
 * Callback function to create an event
 * @param {string} sCommand
 */
UCF_AcfAdapter["prototype"]["createEvent"] = function(sCommand) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createEvent"]++; }; 
	this["mEventParameters"] = {
		"Id": this["sId"],
		"Command": sCommand
	};
	this["bIsServiceEvent"] = false;
	this["iParamCount"] = 0;
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createEvent"] = 0; };

/**
 * Callback function to create a service event
 * @param {string} sCommand
 */
UCF_AcfAdapter["prototype"]["createServiceEvent"] = function(sCommand) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createServiceEvent"]++; }; 
	this["mEventParameters"] = {
		"Id": this["sId"],
		"Command": sCommand
	};
	this["bIsServiceEvent"] = true;
	this["iParamCount"] = 0;
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createServiceEvent"] = 0; };

/**
 * Callback function to add parameters to the event
 * @param {string} sName name
 * @param {string} sValue value
 */
UCF_AcfAdapter["prototype"]["addEventParameter"] = function(sName, sValue) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["addEventParameter"]++; }; 
	this["mEventParameters"]["Name" + this["iParamCount"]] = sName;
	this["mEventParameters"]["Value" + this["iParamCount"]] = sValue;
	this["iParamCount"]++;
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["addEventParameter"] = 0; };

/**
 * Callback function to fire the event
 */
UCF_AcfAdapter["prototype"]["doFireEvent"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["doFireEvent"]++; }; 
	var sEventName = this["bIsServiceEvent"] ? "ServiceEvent" : "Event";
	this["fireSemanticEvent"]("AcfAdapter", sEventName, this["mEventParameters"], false, false, false);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["doFireEvent"] = 0; };

/**
 * Callback function set an attribute of the control
 * @param {string} sName name
 * @param {string} sValue value
 **/
UCF_AcfAdapter["prototype"]["setAttribute"] = function(sName, sValue) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["setAttribute"]++; }; 
	this["fireAttributeChange"](this["sId"], sName, sValue);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["setAttribute"] = 0; };

/**
 * Callback function for tracing
 * @param {string} sClassName
 * @param {string} sMethodName
 * @param {integer} iSeverity
 * @param {string} sDescription
 */
UCF_AcfAdapter["prototype"]["trace"] = function(sClassName, sMethodName, iSeverity, sDescription) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["trace"]++; }; 
	// TODO
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["trace"] = 0; };

/**
 * Callback function to get the current drag session
 *
 * @return {JSONObject} the current drag session in JSON notation or null
 */
UCF_AcfAdapter["prototype"]["getDragSession"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["getDragSession"]++; }; 
	var oDragAndDropManager = this["oLS"]["oBrowserWindow"]["oGetDragAndDropManager"]();
	return oDragAndDropManager["sGetDragSession"]();
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["getDragSession"] = 0; };

/**
 * Callback function to create a new drag session
 *
 * @param {JSONObject} sDragSessionData the drag session
 * @return {string} the drag session id
 */
UCF_AcfAdapter["prototype"]["createDragSession"] = function(sDragSessionData) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createDragSession"]++; }; 
	var oDragAndDropManager = this["oLS"]["oBrowserWindow"]["oGetDragAndDropManager"]();
	return oDragAndDropManager["sCreateDragSession"](sDragSessionData);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createDragSession"] = 0; };

/**
 * Callback function to destroy the current drag session
 *
 * @param {string} sDragSessionId the id of the drag session
 */
UCF_AcfAdapter["prototype"]["destroyDragSession"] = function(sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["destroyDragSession"]++; }; 
	var oDragAndDropManager = this["oLS"]["oBrowserWindow"]["oGetDragAndDropManager"]();
	oDragAndDropManager["destroyDragSession"](sDragSessionId);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["destroyDragSession"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_AcfAdapter["prototype"]["aAttributeNames"] = ["iTimeout","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_AcfAdapter["prototype"]["aEventNames"] = ["Event","ServiceEvent","AttributeChange","ReturnValue","Timeout"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_AcfAdapter["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {number}
 */
UCF_AcfAdapter["prototype"]["iTimeout"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_AcfAdapter["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_AcfAdapter["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["setDefaultValues"]++; }; 
	this["iTimeout"] = 0;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Timeout", 0, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId The id of the AcfAdapter.
 * @param {string} sName0 Generic event parameter name
 * @param {string} sValue0 Generic event parameter value
 * @param {string} sName1 Generic event parameter name
 * @param {string} sValue1 Generic event parameter value
 * @param {string} sName2 Generic event parameter name
 * @param {string} sValue2 Generic event parameter value
 * @param {string} sName3 Generic event parameter name
 * @param {string} sValue3 Generic event parameter value
 * @param {string} sName4 Generic event parameter name
 * @param {string} sValue4 Generic event parameter value
 * @param {string} sName5 Generic event parameter name
 * @param {string} sValue5 Generic event parameter value
 * @param {string} sName6 Generic event parameter name
 * @param {string} sValue6 Generic event parameter value
 * @param {string} sName7 Generic event parameter name
 * @param {string} sValue7 Generic event parameter value
 * @param {string} sName8 Generic event parameter name
 * @param {string} sValue8 Generic event parameter value
 * @param {string} sName9 Generic event parameter name
 * @param {string} sValue9 Generic event parameter value
 * @fires AcfAdapter::Event
 */
UCF_AcfAdapter["prototype"]["fireEvent"] = function(sId, sName0, sValue0, sName1, sValue1, sName2, sValue2, sName3, sValue3, sName4, sValue4, sName5, sValue5, sName6, sValue6, sName7, sValue7, sName8, sValue8, sName9, sValue9) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireEvent"]++; }; 
	/** @type {{Id: string, Name0: string, Value0: string, Name1: string, Value1: string, Name2: string, Value2: string, Name3: string, Value3: string, Name4: string, Value4: string, Name5: string, Value5: string, Name6: string, Value6: string, Name7: string, Value7: string, Name8: string, Value8: string, Name9: string, Value9: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 21, "arguments.length == 21", "AcfAdapter.js(605): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AcfAdapter.js(606): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AcfAdapter.js(607): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName0 != null, "sName0 != null", "AcfAdapter.js(608): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName0) == "string", "typeof(sName0) == \"string\"", "AcfAdapter.js(609): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue0 != null, "sValue0 != null", "AcfAdapter.js(610): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue0) == "string", "typeof(sValue0) == \"string\"", "AcfAdapter.js(611): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName1 != null, "sName1 != null", "AcfAdapter.js(612): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName1) == "string", "typeof(sName1) == \"string\"", "AcfAdapter.js(613): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue1 != null, "sValue1 != null", "AcfAdapter.js(614): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue1) == "string", "typeof(sValue1) == \"string\"", "AcfAdapter.js(615): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName2 != null, "sName2 != null", "AcfAdapter.js(616): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName2) == "string", "typeof(sName2) == \"string\"", "AcfAdapter.js(617): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue2 != null, "sValue2 != null", "AcfAdapter.js(618): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue2) == "string", "typeof(sValue2) == \"string\"", "AcfAdapter.js(619): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName3 != null, "sName3 != null", "AcfAdapter.js(620): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName3) == "string", "typeof(sName3) == \"string\"", "AcfAdapter.js(621): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue3 != null, "sValue3 != null", "AcfAdapter.js(622): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue3) == "string", "typeof(sValue3) == \"string\"", "AcfAdapter.js(623): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName4 != null, "sName4 != null", "AcfAdapter.js(624): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName4) == "string", "typeof(sName4) == \"string\"", "AcfAdapter.js(625): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue4 != null, "sValue4 != null", "AcfAdapter.js(626): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue4) == "string", "typeof(sValue4) == \"string\"", "AcfAdapter.js(627): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName5 != null, "sName5 != null", "AcfAdapter.js(628): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName5) == "string", "typeof(sName5) == \"string\"", "AcfAdapter.js(629): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue5 != null, "sValue5 != null", "AcfAdapter.js(630): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue5) == "string", "typeof(sValue5) == \"string\"", "AcfAdapter.js(631): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName6 != null, "sName6 != null", "AcfAdapter.js(632): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName6) == "string", "typeof(sName6) == \"string\"", "AcfAdapter.js(633): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue6 != null, "sValue6 != null", "AcfAdapter.js(634): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue6) == "string", "typeof(sValue6) == \"string\"", "AcfAdapter.js(635): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName7 != null, "sName7 != null", "AcfAdapter.js(636): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName7) == "string", "typeof(sName7) == \"string\"", "AcfAdapter.js(637): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue7 != null, "sValue7 != null", "AcfAdapter.js(638): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue7) == "string", "typeof(sValue7) == \"string\"", "AcfAdapter.js(639): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName8 != null, "sName8 != null", "AcfAdapter.js(640): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName8) == "string", "typeof(sName8) == \"string\"", "AcfAdapter.js(641): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue8 != null, "sValue8 != null", "AcfAdapter.js(642): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue8) == "string", "typeof(sValue8) == \"string\"", "AcfAdapter.js(643): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName9 != null, "sName9 != null", "AcfAdapter.js(644): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName9) == "string", "typeof(sName9) == \"string\"", "AcfAdapter.js(645): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue9 != null, "sValue9 != null", "AcfAdapter.js(646): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue9) == "string", "typeof(sValue9) == \"string\"", "AcfAdapter.js(647): fireEvent"); };
	mParams = {
		"Id": sId,
		"Name0": sName0,
		"Value0": sValue0,
		"Name1": sName1,
		"Value1": sValue1,
		"Name2": sName2,
		"Value2": sValue2,
		"Name3": sName3,
		"Value3": sValue3,
		"Name4": sName4,
		"Value4": sValue4,
		"Name5": sName5,
		"Value5": sValue5,
		"Name6": sName6,
		"Value6": sValue6,
		"Name7": sName7,
		"Value7": sValue7,
		"Name8": sName8,
		"Value8": sValue8,
		"Name9": sName9,
		"Value9": sValue9
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("AcfAdapter", "Event", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireEvent"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the AcfAdapter.
 * @param {string} sName0 Generic event parameter name
 * @param {string} sValue0 Generic event parameter value
 * @param {string} sName1 Generic event parameter name
 * @param {string} sValue1 Generic event parameter value
 * @param {string} sName2 Generic event parameter name
 * @param {string} sValue2 Generic event parameter value
 * @param {string} sName3 Generic event parameter name
 * @param {string} sValue3 Generic event parameter value
 * @param {string} sName4 Generic event parameter name
 * @param {string} sValue4 Generic event parameter value
 * @param {string} sName5 Generic event parameter name
 * @param {string} sValue5 Generic event parameter value
 * @param {string} sName6 Generic event parameter name
 * @param {string} sValue6 Generic event parameter value
 * @param {string} sName7 Generic event parameter name
 * @param {string} sValue7 Generic event parameter value
 * @param {string} sName8 Generic event parameter name
 * @param {string} sValue8 Generic event parameter value
 * @param {string} sName9 Generic event parameter name
 * @param {string} sValue9 Generic event parameter value
 * @fires AcfAdapter::ServiceEvent
 */
UCF_AcfAdapter["prototype"]["fireServiceEvent"] = function(sId, sName0, sValue0, sName1, sValue1, sName2, sValue2, sName3, sValue3, sName4, sValue4, sName5, sValue5, sName6, sValue6, sName7, sValue7, sName8, sValue8, sName9, sValue9) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireServiceEvent"]++; }; 
	/** @type {{Id: string, Name0: string, Value0: string, Name1: string, Value1: string, Name2: string, Value2: string, Name3: string, Value3: string, Name4: string, Value4: string, Name5: string, Value5: string, Name6: string, Value6: string, Name7: string, Value7: string, Name8: string, Value8: string, Name9: string, Value9: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 21, "arguments.length == 21", "AcfAdapter.js(724): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AcfAdapter.js(725): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AcfAdapter.js(726): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName0 != null, "sName0 != null", "AcfAdapter.js(727): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName0) == "string", "typeof(sName0) == \"string\"", "AcfAdapter.js(728): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue0 != null, "sValue0 != null", "AcfAdapter.js(729): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue0) == "string", "typeof(sValue0) == \"string\"", "AcfAdapter.js(730): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName1 != null, "sName1 != null", "AcfAdapter.js(731): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName1) == "string", "typeof(sName1) == \"string\"", "AcfAdapter.js(732): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue1 != null, "sValue1 != null", "AcfAdapter.js(733): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue1) == "string", "typeof(sValue1) == \"string\"", "AcfAdapter.js(734): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName2 != null, "sName2 != null", "AcfAdapter.js(735): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName2) == "string", "typeof(sName2) == \"string\"", "AcfAdapter.js(736): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue2 != null, "sValue2 != null", "AcfAdapter.js(737): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue2) == "string", "typeof(sValue2) == \"string\"", "AcfAdapter.js(738): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName3 != null, "sName3 != null", "AcfAdapter.js(739): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName3) == "string", "typeof(sName3) == \"string\"", "AcfAdapter.js(740): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue3 != null, "sValue3 != null", "AcfAdapter.js(741): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue3) == "string", "typeof(sValue3) == \"string\"", "AcfAdapter.js(742): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName4 != null, "sName4 != null", "AcfAdapter.js(743): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName4) == "string", "typeof(sName4) == \"string\"", "AcfAdapter.js(744): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue4 != null, "sValue4 != null", "AcfAdapter.js(745): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue4) == "string", "typeof(sValue4) == \"string\"", "AcfAdapter.js(746): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName5 != null, "sName5 != null", "AcfAdapter.js(747): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName5) == "string", "typeof(sName5) == \"string\"", "AcfAdapter.js(748): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue5 != null, "sValue5 != null", "AcfAdapter.js(749): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue5) == "string", "typeof(sValue5) == \"string\"", "AcfAdapter.js(750): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName6 != null, "sName6 != null", "AcfAdapter.js(751): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName6) == "string", "typeof(sName6) == \"string\"", "AcfAdapter.js(752): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue6 != null, "sValue6 != null", "AcfAdapter.js(753): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue6) == "string", "typeof(sValue6) == \"string\"", "AcfAdapter.js(754): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName7 != null, "sName7 != null", "AcfAdapter.js(755): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName7) == "string", "typeof(sName7) == \"string\"", "AcfAdapter.js(756): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue7 != null, "sValue7 != null", "AcfAdapter.js(757): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue7) == "string", "typeof(sValue7) == \"string\"", "AcfAdapter.js(758): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName8 != null, "sName8 != null", "AcfAdapter.js(759): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName8) == "string", "typeof(sName8) == \"string\"", "AcfAdapter.js(760): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue8 != null, "sValue8 != null", "AcfAdapter.js(761): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue8) == "string", "typeof(sValue8) == \"string\"", "AcfAdapter.js(762): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName9 != null, "sName9 != null", "AcfAdapter.js(763): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName9) == "string", "typeof(sName9) == \"string\"", "AcfAdapter.js(764): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue9 != null, "sValue9 != null", "AcfAdapter.js(765): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue9) == "string", "typeof(sValue9) == \"string\"", "AcfAdapter.js(766): fireServiceEvent"); };
	mParams = {
		"Id": sId,
		"Name0": sName0,
		"Value0": sValue0,
		"Name1": sName1,
		"Value1": sValue1,
		"Name2": sName2,
		"Value2": sValue2,
		"Name3": sName3,
		"Value3": sValue3,
		"Name4": sName4,
		"Value4": sValue4,
		"Name5": sName5,
		"Value5": sValue5,
		"Name6": sName6,
		"Value6": sValue6,
		"Name7": sName7,
		"Value7": sValue7,
		"Name8": sName8,
		"Value8": sValue8,
		"Name9": sName9,
		"Value9": sValue9
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("AcfAdapter", "ServiceEvent", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireServiceEvent"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the AcfAdapter.
 * @param {string} sName The name of the changed attribute.
 * @param {string} sValue The new value of the changed attribute.
 * @fires AcfAdapter::AttributeChange
 */
UCF_AcfAdapter["prototype"]["fireAttributeChange"] = function(sId, sName, sValue) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireAttributeChange"]++; }; 
	/** @type {{Id: string, Name: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "AcfAdapter.js(825): fireAttributeChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AcfAdapter.js(826): fireAttributeChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AcfAdapter.js(827): fireAttributeChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName != null, "sName != null", "AcfAdapter.js(828): fireAttributeChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName) == "string", "typeof(sName) == \"string\"", "AcfAdapter.js(829): fireAttributeChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "AcfAdapter.js(830): fireAttributeChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "AcfAdapter.js(831): fireAttributeChange"); };
	mParams = {
		"Id": sId,
		"Name": sName,
		"Value": sValue
	};
	
	
	
	this["fireSemanticEvent"]("AcfAdapter", "AttributeChange", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireAttributeChange"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the AcfAdapter.
 * @param {string} sReturnValue The return value of the invoke call.
 * @fires AcfAdapter::ReturnValue
 */
UCF_AcfAdapter["prototype"]["fireReturnValue"] = function(sId, sReturnValue) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireReturnValue"]++; }; 
	/** @type {{Id: string, ReturnValue: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "AcfAdapter.js(853): fireReturnValue"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AcfAdapter.js(854): fireReturnValue"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AcfAdapter.js(855): fireReturnValue"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sReturnValue != null, "sReturnValue != null", "AcfAdapter.js(856): fireReturnValue"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sReturnValue) == "string", "typeof(sReturnValue) == \"string\"", "AcfAdapter.js(857): fireReturnValue"); };
	mParams = {
		"Id": sId,
		"ReturnValue": sReturnValue
	};
	
	
	this["fireSemanticEvent"]("AcfAdapter", "ReturnValue", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireReturnValue"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the AcfAdapter.
 * @fires AcfAdapter::Timeout
 */
UCF_AcfAdapter["prototype"]["fireTimeout"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireTimeout"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "AcfAdapter.js(876): fireTimeout"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AcfAdapter.js(877): fireTimeout"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AcfAdapter.js(878): fireTimeout"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("AcfAdapter", "Timeout", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireTimeout"] = 0; };

};